module.exports = __webpack_public_path__ + "static/img/NSW-34.9c341c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-34.jpg
// module id = KIEs
// module chunks = 0